export * from 'make-plural/plurals';
